export default {
  noAddress: "No address",
  title: "Structures",
  subtitle: "All platform structures",
  searchPlaceholder: "Search by structure or owner name...",
  loadError: "Failed to load structures",
  retry: "Retry",
  empty: "No structures match your filters.",
  openRowAria: "Open structure {{name}}",
  filters: {
    status: "Status",
    statusAll: "All",
    statusActive: "Active",
    statusInactive: "Inactive",
  },
  columns: {
    name: "Structure",
    owner: "Owner",
    commission: "Commission",
  },
} as const;
